import React, { Component } from 'react';

class AlertConsignmentInventoryModal extends Component {
  render() {
    const { onDeleteAlertConsignment, onClickContinueAlertConsignment } = this.props;
    return (
      <div
        className="modal fade theme-modal qty-modal" id="alertConsignmentInventoryModal"
        tabIndex="-1" aria-labelledby="alertConsignmentInventoryModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <p>Lot # is not in Consignment Inventory</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2 button-wrap">
                <div className="col-6">
                  <button
                    type="button"
                    className="btn btn-link btn-left w-100 alert-modal-btn"
                    data-bs-dismiss="modal"
                    onClick={() => onDeleteAlertConsignment()}
                  >Delete
                  </button>
                </div>
                <div className="col-6">
                  <button
                    type="button"
                    className="btn btn-link w-100 alert-modal-btn"
                    data-bs-dismiss="modal"
                    onClick={() => onClickContinueAlertConsignment()}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AlertConsignmentInventoryModal;
